import React, { Component } from "react";
import { connect } from "react-redux";

class LanguageChecker extends Component {
  constructor() {
    super();

    const availableLanguages = [
      { iso: "en", label: "English" },
      { iso: "de", label: "Deutsch" },
      //{iso:'it',label:'Italiano'},
      //{iso:'es',label:'Español'},
      //{iso:'hu',label:'Magyar'}
    ];

    this.state = {
      availableLanguages,
    };

    this.checkForUserLanguage = this.checkForUserLanguage.bind(this);
  }

  checkForUserLanguage() {
    let browserLang =
      window.navigator.userLanguage || window.navigator.language;
    let language;

    if (this.getCookie("language")) {
      language = this.getCookie("language");
    } else {
      language = browserLang.split("-")[0];
    }

    //console.log("language",language);

    let isLanguageAvailable = false;

    isLanguageAvailable = this.state.availableLanguages.filter((item, i) => {
      return item.iso === language.toLowerCase();
    }).length;

    if (!isLanguageAvailable) {
      language = "en";
    }

    //    console.log('isLanguageAvailable',isLanguageAvailable);

    this.selectLanguage(language.toLowerCase());

    document.querySelector("html").setAttribute("lang", language);
  }

  componentDidMount() {
    this.checkForUserLanguage();
  }

  selectLanguage(currentLanguage) {
    if (currentLanguage) {
      let exdays = 30;

      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();

      document.cookie =
        "language=" + currentLanguage + ";" + expires + ";path=/";

      this.props.setLanguage(currentLanguage);
      console.log("Setting Current Language", currentLanguage);
    } else {
      console.warn("Language not found", currentLanguage);
    }
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  render() {
    return null;
  }
}

const mapStatesToProps = (state) => {
  const currentLanguage = state.KastnerStore.currentLanguage;
  return {
    currentLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLanguage: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "SELECT_LANGUAGE", payload: data });
    },
  };
};

export default connect(mapStatesToProps, mapDispatchToProps)(LanguageChecker);



// WEBPACK FOOTER //
// ./src/modules/multilang/LanguageChecker.js